var productIds = [];
var variantIds = [];
var pointDetails = [];
var playerDetail;
var productTag;
var isClubMemberUser = 0;
var isMemberNotifyRead = 0;
var counter = 0;
var count=0;
var tagGroup = 0;
var scholarshipGroup = 0;
var scholarshipGroupArr = [];
var productTags = [];
var scholarArray = [];
var tayQty = 0;
var myAry = [];
var tagPercentage = 0;
/**  Required Product  **/
 var cartList=cartList;
$(document).ready(function() {
   bogo();
   bundleProductItemRemove();
    var tempPlayerRowId = getCookie("currentlySelected");
  /* for the first time page load the above getcookie line is ignored, so we are not getting currenlty selected player, here i've added new cookie it will set the data after player selection call back function */
  if(!tempPlayerRowId){
     var tempPlayerRowId = getCookie("currentlySelectedNew");
  }

    if (tempPlayerRowId) {
        // No slash before the query string: Laravel 301s ".../?x" to "...?x", doubling
        // the round trip — and this runs on every page load that has a selected player.
        var playerDetailUrl = appBaseUrl + "api/playerSelector?player_id=" + tempPlayerRowId;
        //alert(playerDetailUrl);
        $.ajax({
            type: 'GET',
            url: playerDetailUrl,
            dataType: "jsonp",
            error: function(xhr, status, error) {

            },
        });
    }
    //alert(); //added here
    $.ajax({
        type: 'GET',
        // No slash before the query string — same 301 as above, on every page load.
        url: appBaseUrl + "api/getUserMembershipUrl?customerId=" + loggedCustomerId + "&customerEmail=" + loggedCustomerEmail,
        dataType: "jsonp",
        error: function(xhr, status, error) {

        },
    });

});

function getPlayerDetail(response) {
  var data = response && response.data;

  // Kept for the $(window).on('load') block below, which branches on playerDetail.length==0
  // to choose the non-team required-tag lookup. Only the COOKIE write is guarded.
  playerDetail = data;

  // api/playerSelector answers {status:'failure', data:[]} whenever the temp-player row
  // behind the currentlySelected cookie is gone — and playersTemp:clean deletes those rows
  // after three hours, every thirty minutes. This used to write that [] straight over a
  // valid 7-day getPlayerDetail cookie. api/checkout cannot decode "[]" into a player, so
  // the next Checkout click got a JSON error object back and the shopper was left on
  // "Processing Checkout...".
  //
  // A lookup that fails says nothing about the cookie already in the browser: keep a usable
  // one (it still names the player the shopper chose, so club/scholarship pricing survives
  // the purge), and only clear one that is itself unusable.
  if (!isUsablePlayerDetail(data)) {
    var existingUsable = false;
    try {
      existingUsable = isUsablePlayerDetail(JSON.parse(getCookie('getPlayerDetail')));
    } catch (e) {
      // unparseable — treated as unusable
    }
    if (!existingUsable) {
      delete_cookie('getPlayerDetail');
    }
    return;
  }

  setCookie('getPlayerDetail', JSON.stringify(data));
}

// A player-detail payload api/checkout can act on: an object carrying an id. [] (Records Not
// Found), null, and the result of parsing a truncated cookie all fail this.
function isUsablePlayerDetail(data) {
  return !!(data && typeof data === 'object' && !Array.isArray(data) && data.id);
}
function changeCartQty(itemId,itemQty,type){
 if(type=='minus'){
   var updateQty = itemQty-1;
 }else{
   var updateQty = itemQty+1;
 } 

  var href = $('.'+itemId).attr('href');
  var params = href.split('?');
  var paramsArr = params[1].split('$');
  var lineIdArr = paramsArr[0].split('=');
  var lineId = lineIdArr[1];

  window.location.href = 'https://soccerzoneusa.com/cart/change?line='+lineId+'&quantity='+updateQty;
  
  
}
function setCookie(key, value) {
    var expires = new Date();
   if(key=='clubTempPlayer'){
     document.cookie = key + '=' + value + ';path=/';
  }
  else{
     // 604800 is the number of SECONDS in seven days, but getTime() is milliseconds — so
     // this set every cookie to expire in 604.8 seconds, about ten minutes.
     //
     // That governs getPlayerDetail, which carries player identity to checkout
     // (club-price.js sends it as player_detail, and ClubPriceController::checkout gates
     // the whole discount path on it). A parent spending eleven minutes entering names and
     // numbers for a team order — entirely normal — posted an empty player_detail and
     // landed on plain Shopify checkout at full retail, while the cart in front of them
     // still showed the club subtotal.
     expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000));
    document.cookie = key + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }
   
}

function getProductRequiredTag(response) {

    productTag = response.data;
    setCookie('productTag', JSON.stringify(productTag));
    //alert("PT"+productTag)
    if (productTag == 0) {
        $('[name=custom_checkout]').removeAttr('disabled').removeClass("disable_checkout");
    }
}

$(window).on('load', function() {
    //currentlySelected
    if (playerDetail) {
        if (playerDetail.has_ordered == 0) {
            //if(playerDetail.has_ordered == 0){
          if(playerDetail.team_title=='non-team'){
              var currentlySelectedPlayer = getCookie("currentlySelected");
             var urlParams = new URLSearchParams(window.location.search);
  var slug=urlParams.get('slug');
          var productRequiredTagUrl = appBaseUrl + "api/cart/product/tag-non?slug="+slug+"&productIds=" + JSON.stringify(productIds)+'&currentlySelectedPlayer='+currentlySelectedPlayer;
         
          }else{
            var productRequiredTagUrl = appBaseUrl + "api/cart/product/tag?productIds=" + JSON.stringify(productIds);
          }
            
            //var productRequiredTagUrl = appBaseUrl + "api/cart/product/tag";
           
            $.ajax({
                type: 'GET',
                url: productRequiredTagUrl,
                //type:"POST",
                dataType: 'jsonp',
                contentType: "application/json; charset=utf-8",
                //data: JSON.stringify(productIds),
                processData: false,
                async:true,
                crossDomain:true,
                cache: false,
                error: function(xhr, status, error) {
                 //console.log("error", error, "xhr", xhr, "status", status);
                },
            });
        }else if(playerDetail.length==0){
          var currentlySelectedPlayer = getCookie("currentlySelected");
            var urlParams = new URLSearchParams(window.location.search);
  var slug=urlParams.get('slug');
          var productRequiredTagUrl = appBaseUrl + "api/cart/product/tag-non?slug="+slug+"&productIds=" + JSON.stringify(productIds)+'&currentlySelectedPlayer='+currentlySelectedPlayer;
         // alert(currentlySelectedPlayer);
          $.ajax({
                type: 'GET',
                url: productRequiredTagUrl,
                //type:"POST",
                dataType: 'jsonp',
                contentType: "application/json; charset=utf-8",
                //data: JSON.stringify(productIds),
                processData: false,
                async:true,
                crossDomain:true,
                cache: false,
                error: function(xhr, status, error) {
                 //console.log("error", error, "xhr", xhr, "status", status);
                },
            });
        }
      
      
    }else{

    }
});

if (page == "cart-template") {
    cartList.items.forEach(function(obj) {
        productIds.push(obj.product_id);
        variantIds.push(obj.variant_id);
    });
} else if (page == "players-selection-sidebar" && typeof productDetail != "undefined" && productDetail != null) {
    productIds.push(productDetail.id);
    productDetail.variants.forEach(function(obj) {
        variantIds.push(obj.id);
    });
} else {
    productList.forEach(function(product) {
        productIds.push(product.id);
        product.variants.forEach(function(variant) {
            variantIds.push(variant.id);
        });
    });
}
var clubPrice = appBaseUrl + "api/club-price?customerId=" + customerId + "&productIds=" + JSON.stringify(productIds) + "&variantIds=" + JSON.stringify(variantIds);
$(function() {
    if (loggedCustomerId != null) {
        $.ajax({
            type: 'GET',
            url: clubPrice,
            dataType: "jsonp",
            error: function(xhr, status, error) {

            },
        });
    }


    if (page == "players-selection-sidebar") {
        customerId = customerId != null ? customerId : "";
        var pointsUpdate = appBaseUrl + "api/loyalty/product-points?customerId=" + customerId + "&productIds=" + JSON.stringify(productIds);
        $.ajax({
            type: 'GET',
            url: pointsUpdate,
            dataType: "jsonp",
            error: function(xhr, status, error) {

            },
        });
    }
});

function clubPriceDetailsUpdate(response) {
    switch (page) {
        case "search-template":
            productList.forEach(function(product) {
                var productId = product.id;
                var clubPrice = false;
                var priceVariant = [];
                product.variants.forEach(function(variant) {
                    var variantId = variant.id;
                    if (typeof response[productId] != "undefined") {
                        if (typeof response[productId][variantId] != "undefined") {
                            variant.club_price = response[productId][variantId] * 100;
                            clubPrice = true;
                            priceVariant.push(variant.club_price);
                        } else {
                            priceVariant.push(variant.price);
                        }
                    } else {
                        priceVariant.push(variant.price);
                    }
                });
                if (clubPrice) {
                    var filteredArray = priceVariant.filter(function(item, pos) {
                        return priceVariant.indexOf(item) == pos;
                    });
                    var price_varies = filteredArray.length == 1 ? false : true;
                    var price = Math.min(...priceVariant);
                    var html = "";
                    var from = "From";
                    if (price_varies) {
                        html = '<span class="from">' + from + ' </span>';
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    } else {
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    }

                    $("#product-grid-" + productId + " .price").html(html);
                }
            });
            break;
        case "cart-template":

            //$('[name=custom_checkout]').attr('disabled', 'disabled').addClass("disable_checkout");
            clubPriceCartPage = response;
            
            var subTotal = 0;
            var isShcolor = 0;
            var ShcolorArr = [];
            var discountDetails = ""
            // Wait for the player lookups before rendering. They were previously done one
            // at a time, synchronously, INSIDE this loop — so the browser froze for the
            // duration and the required-products modal could not paint even after its
            // answer had arrived. They now run in parallel and this waits once.
            //
            // .always, not .done: a failed lookup must not abandon the cart render.
            prefetchPlayerDetails(cartList).always(function () {
                cartList.items.forEach(function(obj) {

                    var productId = obj.product_id;
                    var variantId = obj.variant_id;
                    var mm = "input[name='" + productId + "[]']";
                    var tags = $(mm)
                        .map(function() { return $(this).val(); }).get();
                    var price = obj.original_price;
                     discountDetails = obj.line_level_discount_allocations || ""
                    var type = "default";
                    if (typeof response[productId] != "undefined") {
                        if (typeof response[productId][variantId] != "undefined") {
                            price = response[productId][variantId] * 100;
                            type = "club";
                        }
                    }
                        var tv= tags.filter(element => element.includes("club-scholarship-"));
                    
                        if(tv[0]) {
         var maxScholar = tv[0].split("-");
                          var scholGroup =maxScholar[2];
        } else {
          var maxScholar = [];
        }    
                  $("#is_scholar_checkout").val(maxScholar);
        maxScholar = maxScholar[3] ? maxScholar[3] : 0;
                  var playerId = obj.properties['Player ID'];
              
        var checkProdExist = ShcolorArr[productId.playerId];
        //alert(productId+'==>'+checkProdExist);
        if(checkProdExist){
          }else{
           delete_cookie(obj.product_id+playerId);
                 setCookie(obj.product_id+playerId, 0);
          ShcolorArr[productId]=0;
          }
      
                    subTotal += updateCartPrice(obj, price, type, tags ,checkProdExist)/100;
                     ShcolorArr[productId.playerId] += 1;
                    //delete_cookie(obj.product_id);
                    var sub = parseFloat(subTotal);
                    //alert("SUB" + sub);
                });
                $("[data-cart-subtotal]").html(parseFloat(subTotal).toFixed(2));
                $("#disable_subtotal").val(parseFloat(subTotal).toFixed(2));
                $(".data-cart-subtotal").val(parseFloat(subTotal, 10).toFixed(2));
                $(".final").attr("data-cart-subtotal", parseFloat(subTotal).toFixed(2));
                $(".final").html('<span class="money">$' + parseFloat(subTotal).toFixed(2) + '</span>');
            });
            break;
        case "collection-retail-list":
            productList.forEach(function(product) {
                var productId = product.id;
                var clubPrice = false;
                var priceVariant = [];
                product.variants.forEach(function(variant) {
                    var variantId = variant.id;
                    if (typeof response[productId] != "undefined") {
                        if (typeof response[productId][variantId] != "undefined") {
                            variant.club_price = response[productId][variantId] * 100;
                            clubPrice = true;
                            priceVariant.push(variant.club_price);
                        } else {
                            priceVariant.push(variant.price);
                        }
                    } else {
                        priceVariant.push(variant.price);
                    }
                });
                if (clubPrice) {
                    var filteredArray = priceVariant.filter(function(item, pos) {
                        return priceVariant.indexOf(item) == pos;
                    });
                    var price_varies = filteredArray.length == 1 ? false : true;
                    var price = Math.min(...priceVariant);
                    var html = "";
                    var from = "From";
                    if (price_varies) {
                        html = '<span class="from">' + from + ' </span>';
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    } else {
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    }
                    $("#product-grid-" + productId + " .price").html(html);
                }

            });
            break;
        case "collection-retail-template":
            productList.forEach(function(product) {
                var productId = product.id;
                var clubPrice = false;
                var priceVariant = [];
                product.variants.forEach(function(variant) {
                    var variantId = variant.id;
                    if (typeof response[productId] != "undefined") {
                        if (typeof response[productId][variantId] != "undefined") {
                            variant.club_price = response[productId][variantId] * 100;
                            clubPrice = true;
                            priceVariant.push(variant.club_price);
                        } else {
                            priceVariant.push(variant.price);
                        }
                    } else {
                        priceVariant.push(variant.price);
                    }
                });
                if (clubPrice) {
                    var filteredArray = priceVariant.filter(function(item, pos) {
                        return priceVariant.indexOf(item) == pos;
                    });
                    var price_varies = filteredArray.length == 1 ? false : true;
                    var price = Math.min(...priceVariant);
                    var html = "";
                    var from = "From";
                    if (price_varies) {
                        html = '<span class="from">' + from + ' </span>';
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    } else {
                        html += '<span class="money"><span class="money">' + theme.Currency.formatMoney(price, StyleHatch.currencyFormat) + '</span></span>';
                    }

                    $("#product-grid-" + productId + " .price").html(html);
                }

            });
            break;
        case "players-selection-sidebar":
            if (productDetail != null) {
                var productId = productDetail.id;
                productDetail.variants.forEach(function(obj) {
                    var variantId = obj.id;
                    if (typeof response[productId] != "undefined") {
                        if (typeof response[productId][variantId] != "undefined") {
                            obj.club_price = response[productId][variantId];

                            if (variantDefault) {
                                $("#ComparePrice-product-sz-template").show();
                                $("#ComparePrice-product-sz-template .money").html(theme.Currency.formatMoney(obj.price, StyleHatch.currencyFormat));
                                $("#ProductPrice-product-sz-template .custom-price-val").html(theme.Currency.formatMoney(obj.club_price, StyleHatch.currencyFormat));
                            }
                        }
                    }
                });
            } else {
                productList.forEach(function(product) {
                    var productId = product.id;
                    product.variants.forEach(function(variant) {
                        var variantId = variant.id;
                        if (typeof response[productId] != "undefined") {
                            if (typeof response[productId][variantId] != "undefined") {
                                variant.club_price = response[productId][variantId];
                            }
                        }
                    });
                });
            }
        default:
            break;
    }

}

function priceDetailsUpdate() {}


/*--------Cart Page-------*/
$('[name=custom_checkout]').click(function(event) {
    //alert("CORRECT CLICK");
    checkoutSubmitProcess();
});
$('[name=checkout]').click(function(event) {

   
});


// $('[name=checkout]').click(function(event) {
//     alert("CORRECT CLICK");
//     var res =checkoutSubmitProcess(); 
//     if(res){
    
//     return false;

//     }
// });

///

$('#CartDrawer-Form').submit(function(event) {
  // productRequiredVerification();
//prodReqCheckerCallback
// Was getCookie("prodReqCheckerCallback"). See the note by window.reqCheckState — an
    // absent cookie fell through to a success toast and let the shopper check out without
    // the products they were required to have.
    var product_tag = window.reqCheckState;

    if (product_tag === 'pending') {
      // The answer has not arrived. Hold the submit, show that something is happening, and
      // let resolveReqCheck() continue or block once it knows. The only waiting branch,
      // and the timeout in cart.liquid bounds it.
      window.pendingCheckout = true;
      window.setCheckoutWaiting(true);
      return false;
    }

    if(product_tag == 'allow'){
       // The check could not be reached. Failing open is deliberate, but say nothing
       // rather than asserting the cart was verified — which is what the old else did.
    }else if(product_tag == 'success'){
       toastr['success']('You have added all of the required products, be sure to enjoy shopping');
       //alert('You have added all of the required products, be sure to enjoy shopping');
    }else if(product_tag == 'failure'){
      productRequiredVerification();
      // i've added the below line to show the popup untilll getting succes from required API, but if added player and not adding product in the cart and i've added any retail product in the cart the popup will show.. so that removed
      // NOTE - Even If we remove the player the popup will show because we have prodReqCheckerCallback cookie based on this status we will show the required popup.
      // The cookie will if required faile return failure otherwise false.. so that once i've if added any one required product not all, the coookie status will update as failure.. so now if i remove the rproduct and added retails product the popup will show.
       // $("#cartErrorNotifyPopup").css("display", "block");
       toastr['error']('Be sure to add all of the required products to the cart');
       //alert('Be sure to add all of the required products to the cart');
       return false;
    }

 hasMemeberProduct = 0;

  // The "Processing Checkout..." feedback now lives inside checkoutSubmitProcess(), set only
  // once a checkout chain actually starts. Setting it here, before the call, meant a click
  // that checkoutSubmitProcess() refused (one already in flight) re-labelled the button with
  // nothing to put it back — and the resolveReqCheck() → checkoutSubmitProcess() path never
  // showed it at all.
  checkoutSubmitProcess();
  return false;
   
  
  var sch_check=$("#is_scholar_checkout").val();
 
   //alert("YES");
  
  //
  $('#checkDis').css({'background-color':'grey','color':'#fff'});
  //$("#checkDis").html("Processing Checkout...");
  $("#checkDis").prop('value', 'Processing Checkout...');
   
 cartCheckoutProcess("submit");
   // checkoutSubmitProcess();
  if(sch_check!='')
  {
    $('[name=checkout]').attr('disabled', 'disabled');
    return false;
  }
  else
  {
    return true;
  }
});
function validURL(str) {
  var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
  return !!pattern.test(str);
}

// function checkoutSubmitProcess() {
//   console.log("sdsdsdsdsdsd");
//   /* cross verify the required product system */
//   productRequiredVerification();
 
// }

// checkoutSubmitAfterProductRequiredVerification();
var checkoutInFlight = false;

function checkoutSubmitProcess() {
  // There was no guard, so every repeated click fired a fresh POST /cart.js followed by a
  // POST api/checkout. On a slow connection — exactly when people click twice — that meant
  // several concurrent checkout chains racing each other.
  if (checkoutInFlight) {
    return false;
  }

  checkoutInFlight = true;

  // Released on real completion (see the `complete` handler on api/checkout below), with
  // this timer as a BACKSTOP only — for the paths that never reach it, such as the outer
  // POST /cart.js failing.
  //
  // It used to be the sole release mechanism at 10s, which inverted the guard's purpose: a
  // checkout call slower than 10s — precisely when someone clicks again — unlatched the flag
  // while the first chain was still running, so the second click started a concurrent one.
  // 30s is past any api/checkout that is going to succeed, so the backstop now only fires
  // when the request really is gone.
  setTimeout(function () { checkoutInFlight = false; }, 30000);

  // Visible feedback for the chain that is now running. It used to be set by the submit
  // handler BEFORE this function was called, so a click refused by the guard above
  // re-labelled the button with nothing to put it back. Every branch below ends in
  // navigation or restoreCheckoutButton(), so it cannot be left behind.
  $('#checkDis').css({'background-color':'grey','color':'#fff'});
  $("#checkDis").prop('value', 'Processing Checkout...');
    hasMemeberProduct = 0;
    if (isClubMemberUser == 0) {
        if ($(".membership-product").length > 0) {
            hasMemeberProduct = 1;
          isMemberNotifyRead = 1;

            // #cartMemberNotifyPopup does not exist. The markup was removed from
            // layout/theme.liquid in 038e615d (2022-03-01) and this call has shown nothing
            // since — it just returned false, silently aborting checkout.
            //
            // Today's re-entrancy guard made that worse: the submit handler has already
            // greyed the button and set it to "Processing Checkout...", and
            // checkoutInFlight was latched true above. Nothing on this path restored
            // either, so the shopper was left with a dead grey button and no message, and
            // reloading landed in the same state. This fires for EVERY new member, since
            // isClubMemberUser is 0 until the JSONP says otherwise.
            //
            // toastr is loaded before this file on the cart page (cart-template.liquid:792
            // vs :801), so it is available here.
            //
            // The previous wording ("A club membership product is required before checking
            // out") was backwards: this branch fires BECAUSE .membership-product IS in the
            // cart, for a shopper the API has not yet flagged as a club member.
            //
            // !!! THIS ABORT IS A PERMANENT BLOCK AND NEEDS A PRODUCT DECISION !!!
            // hasMemeberProduct resets to 0 at the top of every call, and neither
            // isClubMemberUser nor the cart contents change by clicking again — so a shopper
            // buying their FIRST membership re-enters this branch on every click and can
            // never check out. That has been true since the popup markup was deleted in
            // 038e615d (2022-03-01); before today it aborted silently, which is why it reads
            // as "checkout does nothing" rather than as an error.
            //
            // Not removed here: this was a deliberate acknowledgement gate and dropping it is
            // a product call, not a cleanup. Either restore an acknowledgement UI that sets
            // isMemberNotifyRead and lets the next click through, or delete the branch.
            toastr['error']('Your cart contains a club membership. Please contact the club to have your membership activated before checking out.');

            if (typeof window.setCheckoutWaiting === 'function') {
                window.setCheckoutWaiting(false);
            }

            checkoutInFlight = false;
            return false;
        }
// console.log("hasMemeberProduct",hasMemeberProduct,'isMemberNotifyRead',isMemberNotifyRead);
        // if (hasMemeberProduct == 0 && isMemberNotifyRead == 0) { //change this hasMemeberProduct to 0
        //     isMemberNotifyRead = 1;
        //     $("#cartMemberNotifyPopup").css("display", "block");
        //     return false;
        // }
    }
   
    toastr.options = {
            "closeButton": true,
            "progressBar": true,
            "timeOut": "5000",
        }
       
    var product_tag = getCookie("productTag");
    
    // if(product_tag == 'failure'){
    //     productRequiredVerification();
    // }

  
   $.ajax({
        type: "POST",
        url: '/cart.js',
        dataType: 'json',
        // Same-origin and normally instant, but unbounded until now; a hung request here held
        // "Processing Checkout..." with nothing left to release it.
        timeout: 8000,
        // Had no error handler at all: if this failed, the api/checkout below was never
        // reached, so nothing released checkoutInFlight until the backstop timer and nothing
        // restored the button — a dead "Processing Checkout..." with no explanation.
        error: function () {
            checkoutInFlight = false;
            window.restoreCheckoutButton();
            toastr['error']('Could not read your cart. Please try again.');
        },
        success: function(data) {
             var is_bogo = $("#is_bogo").val();
            var discount = $("#discount-code-text").val();
            var product_tag = getCookie("productTag");
          
          var resData = {"is_bogo":is_bogo,"customerId":customerId,"data":JSON.stringify(data),"discount": discount,"player_detail":getCookie("getPlayerDetail"),"tagGroup":scholarshipGroupArr};
          
            //var checkoutPrice = appBaseUrl + "api/checkout?customerId=" + customerId + "&data=" + JSON.stringify(data) + "&discount=" + discount + "&player_detail=" + getCookie("getPlayerDetail")+ "&tagGroup=" +scholarshipGroupArr;
             var checkoutPrice = appBaseUrl + "api/checkout";
       
            // Every way this request can end must leave the page — navigation is the only
            // thing that takes the button off "Processing Checkout...". The app answers
            // plain text — submitCheckout() or redirectCheckout('<url>') — not JSON, so with
            // dataType 'json' the DESIGNED success route is the error handler (parsererror,
            // status 200). success: only fires when the body really is JSON, which the app
            // emits only for its error objects.
            //
            // Two ways this stranded shoppers, both confirmed against production:
            //   - 200 with an EMPTY body (api/checkout with no player_detail fell off the
            //     end of its function): the old error handler only acted when responseText
            //     was non-empty, so it did nothing, and every further click did nothing.
            //   - 200 with a JSON OBJECT ({"status":"error",...} for an unusable player
            //     cookie, typically "[]" after the temp-player purge): success: called
            //     result.split() on an object and threw, which also skipped complete:, so
            //     checkoutInFlight stayed latched for 30s.
            // Both handlers now go through proceedFromCheckoutResponse(): a redirect URL in
            // the body wins; anything else — empty, JSON, HTML, timeout, CORS, 4xx/5xx —
            // falls open to plain Shopify checkout.
            $.ajax({
                url: checkoutPrice,
                type:"POST",
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                data: JSON.stringify(resData),
                processData: false,
                async:true,
                crossDomain:true,
                // Had no timeout. The app builds a Shopify draft order inside this request
                // (30s curl ceiling plus a 429 back-off), and nothing on the client bounded
                // the wait. 20s is past any checkout that is going to succeed; after that,
                // plain checkout beats a shopper staring at "Processing Checkout...".
                timeout: 20000,
                // The real release point. Every branch below ends in navigation, so this
                // fires milliseconds before the page goes away — but if any branch ever
                // stops navigating, the button frees itself here instead of waiting on the
                // backstop.
                complete: function () {
                    checkoutInFlight = false;
                },
                success: function(result, textStatus, jqXHR) {
                    proceedFromCheckoutResponse(typeof result === 'string' ? result : (jqXHR && jqXHR.responseText));
                },
                error: function(jqXHR) {
                    proceedFromCheckoutResponse(jqXHR && jqXHR.responseText);
                },
            });


        }
    });
}

function redirectCheckout(url) {
    //alert("CHECK" + url);
    window.location = url;
}

function submitCheckout() {
    window.location = "/cart/checkout";
}

/* The one exit for api/checkout, whichever jQuery handler the response lands in. Pulls the
 * URL out of a redirectCheckout('<url>') body; anything else falls open to plain checkout.
 * Must never throw: a throw inside a jQuery callback skips complete: and leaves
 * checkoutInFlight latched. */
function proceedFromCheckoutResponse(body) {
    var url = '';
    try {
        if (typeof body === 'string' && body.indexOf("'") !== -1) {
            url = body.split("'")[1] || '';
        }
        if (validURL(url)) {
            redirectCheckout(url);
            return;
        }
    } catch (e) {
        // fall through to plain checkout
    }
    submitCheckout();
}

function validateDiscountCode() {
  
    var discount = $("#discount-code-text").val();
    if (discount != "") {
        $.ajax({
            type: 'GET',
            url: '/discount/' + discount,
            success: function(data) {
                $.ajax({
                    type: 'GET',
                    url: '/checkout',
                    success: function(response) {
                        if (response.indexOf('id="checkout_clear_discount"') > -1) {
                            var discountCode = $(response).find('[data-reduction-form="true"] .reduction-code .reduction-code__text');
                            if (discountCode.length > 0) {
                                discountCode = discountCode.html()
                                    .match(/([a-z0-9_-]+)\s?/i)[1]
                                    .trim();
                                var discountAmount = $(response).find('[data-checkout-discount-amount-target]').attr("data-checkout-discount-amount-target");
                                $(".discount-code-alert").html(`<div class='discount-code-tag'>` + discountCode + `</div>
<div class='discount-code-amount'>Discount` + priceDisplay(discountAmount) + `</div>`);
                            } else {
//                                 $(".discount-code-alert").html("<div class='discount-code-message'>Code is not valid.</div>");
//                                 $("#discount-code-text").val("");
                               $("#discountPopup").css("display","block");
                                $("#discount-code-text").val("");
                            }

                        }
                    }
                });
            }
        });
    }
}

function delete_cookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
function isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
/* ---------------------------------------------------------------------------
 * Player details, fetched once and in parallel.
 *
 * updateCartPrice() used to make a SYNCHRONOUS cross-origin XHR per cart line item
 * (async:false), round-tripping the result through a cookie it wrote and read three lines
 * later — the cookie existed only because async:false makes a return value impossible to
 * thread back out. That froze the main thread for the whole chain, so:
 *
 *   - no spinner could animate, even if one had existed;
 *   - the required-products JSONP callback could not run even after its response had
 *     arrived. The modal was queued behind a dead tab, which is why shoppers clicked
 *     checkout while waiting.
 *
 * It also sent Content-Type and an Access-Control-Allow-Origin REQUEST header, both
 * non-safelisted, so every call first paid a CORS preflight — 2N serialized round trips
 * rather than N. A plain GET with no custom headers is a "simple request" and skips the
 * preflight entirely, which beats caching it.
 * ------------------------------------------------------------------------- */
var playerDetailsCache = {};

function prefetchPlayerDetails(cart) {
  var ids = [];

  if (cart && cart.items) {
    cart.items.forEach(function (item) {
      var id = item.properties && item.properties['Player ID'];
      // Distinct. The same player commonly appears on several line items, and this was
      // previously fetched once per line rather than once per player.
      if (id && ids.indexOf(id) === -1 && !playerDetailsCache[id]) {
        ids.push(id);
      }
    });
  }

  if (!ids.length) {
    return $.Deferred().resolve().promise();
  }

  var requests = ids.map(function (id) {
    return $.ajax({
      url: appBaseUrl + 'api/players/' + id + '/single',
      method: 'GET',
      timeout: 8000
    }).done(function (response) {
      if (response && response.data && response.data.result) {
        playerDetailsCache[id] = response.data.result;
      }
    }).fail(function () {
      // Cache {} rather than nothing, so updateCartPrice reads undefined fields instead of
      // throwing and the cart still renders. Scholarship pricing falls back to default,
      // which is the safe direction.
      playerDetailsCache[id] = {};
    });
  });

  // Resolve even when a lookup fails — one bad player must not abandon the cart render.
  return $.when.apply($, requests.map(function (r) {
    return r.then(null, function () { return $.Deferred().resolve(); });
  }));
}

/* ---------------------------------------------------------------------------
 * Required-products gate state.
 *
 * Replaced a cookie ('prodReqCheckerCallback', SEVEN DAY expiry). Two faults:
 *
 *   getCookie() returns "" when absent, matching neither 'success' nor 'failure', so
 *   control fell to the else — which fired a GREEN SUCCESS TOAST and proceeded to
 *   checkout. First visit, cleared cookies, or clicking while the check was still in
 *   flight all landed there, and the shopper was told "You have added all of the required
 *   products" on the way to an order missing them.
 *
 *   A verdict computed for one cart snapshot survived a week, so a stale 'success' passed
 *   a cart that had since changed.
 *
 * States: 'pending', 'success', 'failure', 'allow' (unreachable — fail open, deliberately).
 * ------------------------------------------------------------------------- */
window.reqCheckState = 'pending';
window.pendingCheckout = false;
window.reqCheckWatchdog = null;

/* Which attempt the current 'pending' belongs to.
 *
 * 'pending' alone is not enough to identify an attempt. Each check installs its own 8s
 * timer against the same global, so on a slow server two clicks interleave: attempt A times
 * out AFTER attempt B has re-entered 'pending', and A's fail-open consumes B's state. B's
 * real 'failure' then arrives, finds the state already 'allow', and is dropped — and because
 * nothing re-arms 'pending', the gate is off for the rest of the page session.
 *
 * A timer that carries the token it was armed for can tell "the attempt I belong to" from
 * "some later attempt", and stand down for the latter. */
window.reqCheckSeq = 0;
window.reqCheckToken = 0;

/* Fail open if nothing resolves the gate in time.
 *
 * The 8s JSONP timeout only covers a request that was actually SENT. Everything before it —
 * the /cart.js round trip, the cookie parsing, the URL construction — can throw or hang, and
 * a throw inside a jQuery success callback unwinds silently: no request goes out, nothing
 * ever calls resolveReqCheck, and the state sits on 'pending'. The submit handler then holds
 * the button on "Checking required items…" indefinitely, and clicking again or reloading
 * reproduces it, because the cause (an absent or truncated cookie) has not changed.
 *
 * So the watchdog is armed against the STATE, not against any one request. It is the
 * backstop for every path that can strand the gate, including ones not yet written.
 *
 * 12s: comfortably past the 8s JSONP timeout, so a slow-but-working check still wins and the
 * watchdog only fires when nothing else will. */
window.armReqCheckWatchdog = function (ms) {
  if (window.reqCheckWatchdog) {
    clearTimeout(window.reqCheckWatchdog);
  }

  var token = window.reqCheckToken;

  window.reqCheckWatchdog = setTimeout(function () {
    window.resolveReqCheck('allow', token);
  }, ms || 12000);
};

/* Enter the waiting state. Every site that begins a check must go through this, so that
 * arming the watchdog and taking a token cannot be forgotten.
 *
 * Returns the token: a caller with its own timers (the JSONP timeout, the /cart.js error
 * handler) should capture it and pass it back, so a reply belonging to an abandoned attempt
 * cannot resolve the current one. */
window.beginReqCheck = function () {
  window.reqCheckState = 'pending';
  window.reqCheckToken = ++window.reqCheckSeq;
  window.armReqCheckWatchdog();

  return window.reqCheckToken;
};

/* Idempotent: a JSONP script arriving after the timeout must not undo the decision.
 *
 * token is optional. Callers that can identify their attempt should pass it; the bare JSONP
 * callbacks cannot (they are global functions Shopify's response invokes by name), and for
 * them the 'pending' check alone is the guarantee. */
window.resolveReqCheck = function (state, token) {
  if (window.reqCheckState !== 'pending') {
    return;
  }

  if (typeof token !== 'undefined' && token !== window.reqCheckToken) {
    return;
  }

  if (window.reqCheckWatchdog) {
    clearTimeout(window.reqCheckWatchdog);
    window.reqCheckWatchdog = null;
  }

  window.reqCheckState = state;
  window.setCheckoutWaiting(false);

  if (!window.pendingCheckout) {
    return;
  }

  window.pendingCheckout = false;

  if (state === 'failure') {
    if (typeof productRequiredVerification === 'function') {
      productRequiredVerification();
    }
    toastr['error']('Be sure to add all of the required products to the cart');
    return;
  }

  checkoutSubmitProcess();
};

/* Capture the button's resting label ONCE, at load, before anything can overwrite it.
 *
 * It used to be captured lazily inside setCheckoutWaiting's `waiting` branch. That branch is
 * mutually exclusive with the submit path that greys the button, so on the submit path there
 * was never a label to restore — and the abort paths had nothing to put back. */
window.captureIdleCheckoutLabel = function () {
  var $btn = $('#checkDis');

  if ($btn.length && !$btn.data('idle-label')) {
    $btn.data('idle-label', $btn.prop('value') || $btn.text());
  }
};

/* Put the button back to rest — label AND appearance.
 *
 * The submit path sets background-color and color as INLINE styles. Nothing anywhere reset
 * them, so every aborted checkout left a permanently grey button reading "Processing
 * Checkout..." even though the click handler would still work. Clearing to '' removes the
 * inline declaration and lets the stylesheet win again, rather than hardcoding a colour here
 * that would drift from the theme. */
window.restoreCheckoutButton = function () {
  var $btn = $('#checkDis');

  if (!$btn.length) {
    return;
  }

  var label = $btn.data('idle-label');

  if (label) {
    $btn.prop('value', label);
  }

  $btn.css({ 'background-color': '', 'color': '' });
  $('.cart-loader-icon').hide();
};

/* The only wait signal this cart has ever had. The button is deliberately NOT disabled:
 * an unreachable app server must never block checkout. */
window.setCheckoutWaiting = function (waiting) {
  var $btn = $('#checkDis');

  if (!$btn.length) {
    return;
  }

  if (waiting) {
    window.captureIdleCheckoutLabel();
    $btn.prop('value', 'Checking required items…');
    $('.cart-loader-icon').show();
  } else {
    window.restoreCheckoutButton();
  }
};

$(function () {
  window.captureIdleCheckoutLabel();
});

/* The page-load 'pending' above is a state nothing is yet committed to resolving: whether a
 * check is ever issued depends on the cart contents and on cookies that may be absent. Arm
 * the watchdog for it too, so a page that never reaches beginReqCheck() still fails open
 * instead of holding the button forever. */
window.armReqCheckWatchdog();

function updateCartPrice(obj, price, type, tags, isShcolor) {

     const properties=obj.properties;
  
  var player_details11 = getCookie("getPlayerDetail");
  if(!player_details11){
    getSelectedPlayerDetails(properties['Player ID']);
    
  }

    // Guarded. player_details11 is null whenever the getPlayerDetail cookie is absent — a
    // first visit, or cleared cookies — and JSON.parse(null) returns null, so the original
    // .id threw a TypeError and killed the entire cart render.
    var player_dets = null;

    try {
        player_dets = player_details11 ? JSON.parse(player_details11) : null;
    } catch (e) {
        player_dets = null;
    }

    var tempPlayerRowId = player_dets && player_dets.id ? player_dets.id : '';
    var playerDetailUrl = appBaseUrl + "api/players/" + properties['Player ID'] + "/single";
    
    // Read from the cache filled by prefetchPlayerDetails() before the cart loop runs.
    // Defaults to {} so a player the prefetch could not resolve reads as absent fields
    // rather than throwing. Only has_ordered_scholarship and scholarship_group are used.
    var player_details_obj = playerDetailsCache[properties['Player ID']] || {};
    var changeQty = obj.quantity;

    if (typeof tv !== 'undefined' && Array.isArray(tv) && tv.length > 0) {
        var tagScholar = tv[0].split("-");
    } else {
        var tagScholar = [];
    }
    var tagValue = tags[1];


    if (tagScholar && tagScholar[3]) {
        tagGroup = tagScholar[2] ? tagScholar[2] : '';
        tayQty = tagScholar[3] ? tagScholar[3] : '';
        tagPercentage = tagScholar[4] ? tagScholar[4] : 0;
        //alert("ccc");
    }

    if (player_details_obj.has_ordered_scholarship == "0" && player_details_obj.scholarship_group && player_details_obj
        .scholarship_group == tagScholar[2]) { //alert("YES");
        var results = tags.filter(function(v) {
            return /club-scholarship-/.test(v)
        });
        var results_length = results.length;
        productCookie=obj.product_id+''+tempPlayerRowId;
        var testCount = getCookie(productCookie);
      console.log('getproductcookie',getCookie(obj.product_id+tempPlayerRowId),'obj.product_id',obj.product_id,'tempPlayerRowId',tempPlayerRowId,'add_two',obj.product_id+tempPlayerRowId);
      console.log('tayQtytayQtytayQty',"sd",obj.product_id,tempPlayerRowId,obj.product_id+tempPlayerRowId);
        console.log("isShcolor", "player=>" + player_details_obj.player_first + ', schol group=>' + player_details_obj
            .scholarship_group + ", tag grp=>" + tagScholar[2]+ ',usedcount=>'+testCount+', total sch=>'+tayQty);
      console.log("results_length",results_length,'testCount',testCount,'tayQty',tayQty)
        if (results_length > 0 && testCount < tayQty) {
            var results_str = results + "";
            var split_str = results_str.slice(-1);
            var qtyFn = tayQty - testCount;
          console.log('tayQtytayQty',tayQty,'testCounttestCount',testCount);
            changeQty = parseInt(obj.quantity) - parseInt(qtyFn);
            if (changeQty < 0) {
                changeQty = 0;
            }
            var number = 1;
            var usedSchol = parseInt(testCount) + parseInt(obj.quantity);
            console.log('isschol', obj.product_id + '==>bal==>' + changeQty + ',used=' + testCount + ',total=' + obj
                .quantity);
            setCookie(productCookie, usedSchol);


        }

    }

    //delete_cookie(obj.product_id);
    price = parseFloat(price);
  //updateShopifyCart(obj.product_id);
    var parent = $("[data-cart-item='" + obj.key + "']");

     
  
    var unitPrice = '<p><span class="money final-price" data-cart-item-final-price="">' + priceDisplay(price) +
        '</span></p> '
      // + '<ul class="cart-item-discounts">' +
      //                         
      //                            +
      //                       '</ul>';
    if (type === "club") {
        var unitPrice = '<p><span class="money final-price" data-cart-item-final-price="">' + priceDisplay(price) +
            '</span></p>';
    }
   
    if(tagPercentage && player_details_obj.scholarship_group && player_details_obj.has_ordered_scholarship == "0") {
          var numVal2 = Number(tagPercentage) / 100;
        var numValTotal = price - (price * numVal2);
         if(tayQty > obj.quantity) {
          var lineItemTotal =  obj.quantity * numValTotal;
          lineItemTotal = parseFloat(lineItemTotal);
         } else {
           var firstTotal = tayQty * numValTotal;
           var secondTotal = changeQty * price;
           var lineItemTotal = parseFloat(firstTotal) +  parseFloat(secondTotal);
         }
    } else {
          var lineItemTotal = changeQty * price;
    }
    parent.find(".cart-item-price").html(unitPrice);

    var label = parent.find(".cart-item-total").attr("data-mobile-label");
    var lineItemFinalPrice = '<div class="mobile-label">' + label + '</div>';
    //alert(obj.original_line_price);
    if (type === "club") {
        lineItemFinalPrice += '<p><span class="money" data-cart-item-line-price="">' + priceDisplay(lineItemTotal) +
            '</span></p>';
    } else {
        lineItemFinalPrice += '<p><span class="money" data-cart-item-original-price="">' + priceDisplay(lineItemTotal) +
            '</span></p>';
    }

    parent.find(".cart-item-total").html(lineItemFinalPrice);
    //parent.find(".cart-item-total").html('<p>0.00<p>');

       setCookie("getPlayerDetail",player_details11);
    return lineItemTotal;
}

function priceDisplay(price) {
    return theme.Currency.formatMoney(price, StyleHatch.currencyFormat);
}
/*--------Cart Page-------*/
function bogo(){
   var sum =0;
    var num=0;
  var bogodiscount;
if (page == "cart-template") {
      cartList.items.forEach(function(obj) {
        var price = obj.final_price;
        var quantity = obj.quantity;
        var productId = obj.product_id;
        var variantId = obj.variant_id;
        var mm = "input[name='" + productId + "[]']";
        var tags = $(mm)
                    .map(function() { return $(this).val(); }).get();
      
       let result = tags.toString();
        
    
     if( result.indexOf('sz-bogo') >= 0){
         $('#is_bogo').val('Yes');
       var tv= tags.filter(element => element.includes("sz-bogo"));
        const tagArray = tv.toString().split(",");
           
        if(obj.quantity>1){
          var quantity=Math.floor(obj.quantity/2);
            
           var parent = $("[data-cart-item='" + obj.key + "']");
           var total =(parseFloat(price)*(obj.quantity));
           var disc= (parseFloat(price)*quantity);
           bogodiscount=total-disc;

                $.each(tagArray, function (key, val) {
                      
                  var tag_array = val.split("-");
                  let number_value = tag_array[2];
                  let percentage_value = tag_array[3];
                  if(number_value){
                    var numdisc= (parseFloat(price)*Math.floor(number_value));
                     bogodiscount=total-numdisc;  
                  if(percentage_value){
                    var perc_price=(price/100)*percentage_value;
                    var perdisc= (parseFloat(perc_price)*Math.floor(number_value));
                     bogodiscount= total-perdisc;  
                 }
                 }
                  
          });
           var label = parent.find(".cart-item-total").attr("data-mobile-label");
           var lineItemFinalPrice = '<div class="mobile-label">' + label + '</div>';
        //lineItemFinalPrice += '<p><span class="money" data-cart-item-original-price="">' + priceDisplay((obj.original_line_price)) + '</span></p>';
           lineItemFinalPrice += '<p><span class="money" data-cart-item-original-price="">' + priceDisplay(bogodiscount) +
            '</span></p>';
   

           parent.find(".cart-item-total").html(lineItemFinalPrice);
        
          sum+= bogodiscount;
           
        }
       
        
      }
        
    });
  if(sum){
  var subTotal=sum/100;
            $("[data-cart-subtotal]").html(parseFloat(subTotal).toFixed(2));
            $("#disable_subtotal").val(parseFloat(subTotal).toFixed(2));
            $(".data-cart-subtotal").val(parseFloat(subTotal, 10).toFixed(2));
            $(".final").attr("data-cart-subtotal", parseFloat(subTotal).toFixed(2));
            $(".final").html('<span class="money">$' + parseFloat(subTotal).toFixed(2) + '</span>');
  }
}
}

function earnPointsDetailsUpdate(response) {
    pointDetails = response;
}


function getUserMembershipUrlCallback(response) {
    isClubMemberUser = response.is_club_member;
}

 function productRequiredVerification(){
    // alert("ds");
    var processedType ="alert-only";

    // MUST come first, before the /cart.js round trip and before any early return below.
    //
    // resolveReqCheck() only acts while the state is 'pending' — that is what makes a late
    // JSONP reply harmless. But both callers of this function reach it when the state is
    // already 'failure', so without this line every resolveReqCheck() call inside it is a
    // silent no-op, including the fail-open ones. The state could then never leave 'failure':
    // a shopper who added the missing product was told to add it again on every click,
    // forever, whatever was in their cart.
    //
    // Re-entering 'pending' here also re-arms the watchdog, so this attempt is covered even
    // if it strands.
    var cartToken = window.beginReqCheck();

   $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      // /cart.js is same-origin and normally instant, but "normally" is not a guarantee and
      // this request gates the checkout button. Without these the gate strands on a hung or
      // failed request; the watchdog would eventually free it, but failing open at the point
      // of failure is faster and says why.
      timeout: 8000,
      error: function () {
        window.resolveReqCheck('allow', cartToken);
      },
      success: function (data) {
        cartItems = data.items;
        var productIdQty = {};
        var productIdPlayers = {};
         var tempSelectedPlayerId="";
        $(cartItems).each(function(index, val) {
          /*var array = $.map(myObj, function(value, index){
              return [value];
          });*/
          if( typeof val.properties !== 'undefined' && val.properties !== null ) {
            if (typeof productIdQty[val.product_id] === "undefined") {
              productIdQty[val.product_id] =  parseInt(val.quantity);
            //  alert(val.properties);
              if (typeof val.properties["Player ID"] !== "undefined") {
                  productIdPlayers[val.product_id] =  val.properties["Player ID"];
              }
              tempSelectedPlayerId=val.properties["Team ID"];
            } else {
             // alert(val.properties["Player Id"]);
              productIdQty[val.product_id] =  parseInt(productIdQty[val.product_id])+parseInt(val.quantity);
              if (typeof val.properties["Player ID"] !== "undefined") {
                  productIdPlayers[val.product_id] =  productIdPlayers[val.product_id]+","+val.properties["Player ID"];
              }
            }
          }
        });
        
 var tempPlayer = getCookie("clubTempPlayer");
        if((Object.keys(productIdPlayers).length==0)&&(tempPlayer) ){

          // Same guard as the sibling branch below, and needed for the same reason: a
          // truthy cookie is not a parseable one. setCookie() writes JSON.stringify(club)
          // with no encodeURIComponent, so a semicolon anywhere in the club's admin-authored
          // notification text truncates the value at that semicolon; a legacy row with a
          // NULL shopifyCollectionId produces the same shape. Either way parsedData[1] is
          // undefined and .split() throws.
          //
          // The throw unwinds this whole success callback — it does NOT skip an item. That
          // means the JSONP below is never sent, so its 8s fail-open never runs either: the
          // fail-open lives on a request that was never made. Before the gate existed the
          // same throw was harmless, because checkout was not waiting on anything.
          if (tempPlayer.indexOf('"shopifyCollectionId":"') === -1) {
            window.resolveReqCheck('allow');
            return;
          }

           var parsedData = tempPlayer.split('"shopifyCollectionId":"');
          var shopifyCollectionId = parsedData[1].split('","');
          //alert(shopifyCollectionId[0]);
          var productReqCheckerUrl = appBaseUrl+"api/productRequiredNonChecker?productIdQty="+JSON.stringify(productIdQty)+"&s_collection_id="+shopifyCollectionId[0]+"&requiredNon=yes&players="+JSON.stringify(productIdPlayers)+"&processedType="+processedType;
        
        
    
        }else{
          var tempPlayer = getCookie("getPlayerDetail");
         
          if(tempPlayer){
          var newData = JSON.parse(tempPlayer);
             var tempPlayerRowId = getCookie("currentlySelected");
            //alert(tempPlayerRowId);
          if(newData.team.title=='non-team'){
            var tempPlayer = getCookie("clubTempPlayer");

          // Guarded. getCookie returns "" when the cookie is absent, so the split below
          // produced undefined and threw — inside the /cart.js success callback, which
          // meant the required-products request was never issued at all. reqCheckState
          // stayed 'pending' forever, and the submit handler held the button on
          // "Checking required items…" with nothing left alive to resolve it. Waiting did
          // not help and clicking again did not help.
          //
          // clubTempPlayer is written without an expiry and is deleted outright by
          // players_list.js, while the Shopify cart outlives both — so an absent cookie
          // here is ordinary, not exceptional.
          //
          // resolveReqCheck('allow') is the deliberate fail-open path: we cannot determine
          // requirements for this cart, so do not block checkout.
          //
          // The `return` EXITS THE WHOLE /cart.js SUCCESS CALLBACK. The $(cartItems).each()
          // above has already closed by this point, so nothing further runs for this cart —
          // in particular the beginReqCheck() and the JSONP below are skipped. That is why
          // the fail-open must be called here rather than left to the request's own error
          // handler: there will be no request. (An earlier comment here claimed this return
          // was a per-item continue. It is not, and a future edit trusting that would strand
          // the gate.)
          if (!tempPlayer || tempPlayer.indexOf('"shopifyCollectionId":"') === -1) {
            window.resolveReqCheck('allow');
            return;
          }

          var parsedData = tempPlayer.split('"shopifyCollectionId":"');
          var shopifyCollectionId = parsedData[1].split('","');
          //alert(shopifyCollectionId[0]);
          var productReqCheckerUrl = appBaseUrl+"api/productRequiredNonChecker?productIdQty="+JSON.stringify(productIdQty)+"&s_collection_id="+shopifyCollectionId[0]+"&requiredNon=yes&players="+tempPlayerRowId+"&processedType="+processedType;
        
          }else{
            var productReqCheckerUrl = appBaseUrl+"api/productRequiredChecker?productIdQty="+JSON.stringify(productIdQty)+"&requiredNon=no&players="+JSON.stringify(productIdPlayers)+"&processedType="+processedType;
       
          }
          } 
           
        }
        // No branch above assigned a checker URL — the cart carries no player cookies at
        // all (a plain retail or guest cart), so there is no requirement to check and no
        // request to send. Fail open NOW. Without this, $.ajax({url: undefined}) fetched
        // the cart page ITSELF (~180 KB of HTML) as a JSONP script on every such load,
        // only to error out at the 8s timeout and allow anyway.
        if (typeof productReqCheckerUrl === 'undefined') {
          window.resolveReqCheck('allow');
          return;
        }

        // Re-arms the watchdog for the request about to go out, and takes the token this
        // request's own timeout will be judged against.
        var reqToken = window.beginReqCheck();

        $.ajax({
          type:'GET',
          url: productReqCheckerUrl,
          dataType: "jsonp",
          // JSONP has no native timeout and no error event, so without this a hung app
          // server left the shopper waiting indefinitely with nothing on screen to say so.
          timeout: 8000,
          error: function(xhr, status, error) {
            // Fail open: an unreachable check must never block checkout. Deliberately NOT
            // the old commented-out window.location redirect — forcing navigation is far
            // blunter than permitting the submit that already works.
            //
            // Scoped to reqToken so THIS request's timeout can only resolve THIS attempt. On
            // a slow server an abandoned attempt's 8s timer otherwise fires after a newer
            // attempt has re-entered 'pending' and allows it through, and the newer attempt's
            // real verdict is then dropped as a late arrival.
            window.resolveReqCheck('allow', reqToken);
          },
        });
      }
    });
    
  }

  function prodReqCheckerCallbackCheckoutButtonClick(response) { 
    if (response.status == "success") {
          //alert(response.status);

     // if (response.processedType == 'submit') {
        $(".additional-checkout-buttons").css("display", "block");
      	checkoutSubmitAfterProductRequiredVerification();//Validation success. so, proceed to checkout
      //}
    } else {
      //Validation failure.So display the error popup message.
      $(".additional-checkout-buttons").css("display", "none");
      
      cartErrorData.cartErrors = response;
      // grab the source
      var source = document.querySelector("#cart_error_template").innerHTML;
      // compile it using Handlebars
      var template = Handlebars.compile(source);
      // get the HTML after passing the template the context
      var html = template(cartErrorData);
      // get the element to set the new HTML into
      var destination = document.querySelector(".cart-errors");
      // set the new HTML
      destination.innerHTML = html;
      $(".cart-errors").css("display","contents");
      $("#cartErrorNotifyPopup").css("display","block");
      return false;
    }
  }
  function getSelectedPlayerDetails(playerId) {
   $.ajax({
        // dataType 'jsonp' rides a <script> tag; jQuery silently ignores custom headers
        // on the script transport, so the Accept/Content-Type block that sat here did
        // nothing except suggest this was an XHR. It is not.
      	url: appBaseUrl+'api/playerSelector',
        type:'GET',
      	data:{
          player_id:playerId,
        },
        dataType: "jsonp",

      });

  
  }

  function bundleProductItemRemove(){
    if(cartList && cartList.items.length>0){
      cartList.items.forEach(function(obj) {
     if(obj.properties.Bundle_Product=="yes"){
       $(".remove-bundle-product-all").css('display','block');
     }
   });
    }
   
}
 async function removeAlBundleProduct(){
$('.cart-loader-icon').css('display','block');
    $('.cart-loader-icon').css('text-align','center');
   for (let key = 0; key < cartList.items.length; key++) {
    const obj = cartList.items[key];
    if (obj.properties.Bundle_Product == "yes") {
      await removeitemsFromCart(obj.id);
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 1 second before the next iteration
    }
   }
$('.cart-loader-icon').css('display','none');
  window.location.href="https://soccerzoneusa.com/cart";
}
async function removeitemsFromCart(variantId){
 var quantity=0;

  var data = {
      'id': variantId,
      'quantity': 0 // Setting quantity to 0 removes the item
    };
 var url="/cart/change.js";
   $.ajax({
        // Headers here were ignored too (script transport) — see getSelectedPlayerDetails.
        // The POST verb is also coerced to GET by the <script> tag; /cart/change.js
        // happens to accept that. Sequencing lives in removeAlBundleProduct's sleeps.
      	url: url,
        type:'POST',
      	data:data,
        dataType: "jsonp",

      });
}


  

  